module.exports = __webpack_public_path__ + "img/02非煤露天矿行业.3e218435.jpg";